import { createApiRef } from '@backstage/core-plugin-api';

import {
  FeatureTree,
  QualityScore,
  QualityScoreHistoryEntry,
  QualityScoreSummary,
} from '@internal/backstage-plugin-scores-common';

export const qualityScoresApiRef = createApiRef<QualityScoresApi>({
  id: 'plugin.scores.quality-scores',
});

/** Reads Quality Scores from the scores-backend plugin. */
export interface QualityScoresApi {
  /** Latest score per scored entity. */
  listLatest(): Promise<QualityScoreSummary[]>;
  /** Latest full score for an entity, or null if it has never been scored. */
  getLatest(entityRef: string): Promise<QualityScore | null>;
  /** Score history for an entity, newest first. */
  getHistory(
    entityRef: string,
    options?: { limit?: number; since?: string },
  ): Promise<QualityScoreHistoryEntry[]>;
  /** Feature tree recorded with the latest score, or null if there is none. */
  getFeatureTree(entityRef: string): Promise<FeatureTree | null>;
}
